export default {"src":"/_next/static/media/droplet.7fd48ac9.svg","height":27,"width":27};